import './App.css';
import React, { Component } from 'react'
import Navigation from './components/Navigation';
import Home from './components/Home';
import Footer from './components/Footer'
import Doctors from './components/Doctors'
import Contact from './components/Contact'
import NotFound from './components/NotFound'
import {BrowserRouter, Route, Switch} from 'react-router-dom'

import 'firebase/auth'
import base, { firebaseApp} from "./base"
import frenchTraduction from './traduction/french'
import englishTraduction from './traduction/english'
import Admin from './components/Admin'
import Login from './components/Login'

export default class App extends Component {

  state = {
    frenchLanguage: {...frenchTraduction},
    englishLanguage: {...englishTraduction},
    englishSelected : false,
    homeSelected : true,
    doctorsSelected : false,
    contactSelected : false,
    displayMenu: false,
    doctors: {},
    user: {},
    uid: '',
    displayInformation: true,
    information: {},
    data: {},
    isAnnexeDisplay: false
  }
  

  handleHome = () => {
    const homeSelected = true
    const doctorsSelected = false
    const contactSelected = false
    const displayMenu = false
    this.setState({homeSelected, doctorsSelected, contactSelected, displayMenu}) 
  }

  handleDoctors = () => {
    const homeSelected = false
    const doctorsSelected = true
    const contactSelected = false
    const displayMenu = false
    this.setState({homeSelected, doctorsSelected, contactSelected, displayMenu})
    window.scrollTo(0, 0);
  }

  handleContact = () => {
    const homeSelected = false
    const doctorsSelected = false
    const contactSelected = true
    const displayMenu = false
    this.setState({homeSelected, doctorsSelected, contactSelected, displayMenu})
  }

  handleLanguage = () => {
    let englishSelected = this.state.englishSelected
    if(englishSelected){
      englishSelected = false
    }else{
      englishSelected = true
    }
    this.setState({englishSelected})
  }

  handleMenu = () => {
    let displayMenu = this.state.displayMenu
    if(displayMenu){
        displayMenu = false
    }else{
        displayMenu = true
    }
    this.setState({displayMenu})
  }

  handleInformation = () => {
    let displayInformation = this.state.displayInformation
    if(displayInformation){
      displayInformation = false
    }else{
      displayInformation = true
    }
  this.setState({displayInformation})
  }

  handleIsAnnexeDisplay = (type) => {
    let isAnnexeDisplay = ''
    if (type === "annexe"){
      isAnnexeDisplay = true
    }else{
      isAnnexeDisplay = false
    }
    this.setState({isAnnexeDisplay})
  }

  handleButtonDoctorType = (type) => {
    let isAnnexeDisplay = ''
    if (type === "annexe"){
      isAnnexeDisplay = true
    }else{
      isAnnexeDisplay = false
    }

    this.setState({isAnnexeDisplay})
    this.handleDoctors()
  }

  componentDidMount() {
    this.authListener()
   
    
    base.syncState('/information', {
      context: this,
      state: 'information'
    })
    base.syncState('/doctors', {
      context: this,
      state: 'doctors'
    })
  
  }

  authListener(){
    firebaseApp.auth().onAuthStateChanged((user) => {
        if(user){
            const uid = user.uid
            this.setState({user, uid})
            //localStorage.setItem('user', user.uid)
        }else{
            this.setState({user:null})
           // localStorage.removeItem('user')
        }
    })
  }

  handleAdminChange = (key, doctor) => {
    const doctors = { ... this.state.doctors}
    doctors[key] = doctor
    this.setState({ doctors })
  }

  handleInformationChange = (information) => {
    this.setState({information})
  }




  
  render() {
    const doctorsSelected = this.state.doctorsSelected
    const contactSelected = this.state.contactSelected

    const dataDoctors = { ... this.state.doctors}
    const uid = this.state.uid
    const dataInformation = { ... this.state.information}

    return (
    
        <BrowserRouter>
          <Switch>
            <Route exact path='/'>
              <Navigation
                englishSelected={this.state.englishSelected} 
                englishLanguage={this.state.englishLanguage} 
                frenchLanguage={this.state.frenchLanguage}
                homeLink={this.handleHome}
                doctorsLink={this.handleDoctors}
                contactLink={this.handleContact}
                languageLink={this.handleLanguage}
                homeSelected={this.state.homeSelected}
                doctorsSelected={this.state.doctorsSelected}
                contactSelected={this.state.contactSelected}
                handleMenu={this.handleMenu}
                displayMenu={this.state.displayMenu}
              />
              {doctorsSelected ? <Doctors 
                                    englishLanguage={this.state.englishLanguage} 
                                    frenchLanguage={this.state.frenchLanguage} 
                                    englishSelected={this.state.englishSelected}
                                    handleInformation={this.handleInformation}
                                    displayInformation={this.state.displayInformation}
                                    information={dataInformation}
                                    doctors={dataDoctors}
                                    isAnnexeDisplay={this.state.isAnnexeDisplay}
                                    handleIsAnnexeDisplay={this.handleIsAnnexeDisplay}/>
                : contactSelected ? <Contact 
                                      englishLanguage={this.state.englishLanguage} 
                                      frenchLanguage={this.state.frenchLanguage} 
                                      englishSelected={this.state.englishSelected}
                                      doctors={dataDoctors}
                                      isAnnexeDisplay={this.state.isAnnexeDisplay}
                                      handleIsAnnexeDisplay={this.handleIsAnnexeDisplay}
                                    /> 
                : <Home englishLanguage={this.state.englishLanguage} 
                                    frenchLanguage={this.state.frenchLanguage}
                                    englishSelected={this.state.englishSelected} 
                                    doctorsLink={this.handleDoctors}
                                    handleInformation={this.handleInformation}
                                    displayInformation={this.state.displayInformation}
                                    information={dataInformation}
                                    handleButtonDoctorType={this.handleButtonDoctorType}
                                    isAnnexeDisplay={this.state.isAnnexeDisplay}
                              /> }

           
              <Footer englishLanguage={this.state.englishLanguage} frenchLanguage={this.state.frenchLanguage}/>
            </Route>

            <Route exact path='/modifications-informations'>
              {this.state.user ? 
                <Admin 
                handleAdminChange={this.handleAdminChange}
                doctors={this.state.doctors}
                uid={uid}
                information={this.state.information}
                handleInformationChange={this.handleInformationChange}
                /> 
                : <Login /> }
            </Route>
            
          
            <Route component={NotFound} />
          </Switch>
        </BrowserRouter>
        
  
      
    )
  }
}
